import { MessageBar } from '@repo/ui/components';
import { TMessageBarSeverity } from 'types';

export const GeneralWarning = ({ message }: { message?: string }) => {
  return message ? (
    <MessageBar severity={TMessageBarSeverity.NEUTRAL}>
      <span className="text-white text-base/[175%] font-semibold">{message}</span>
    </MessageBar>
  ) : null;
};
